import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Toasted from 'vue-toasted';
import scrollTo from 'vue-scrollto';

/* Font awesome */
import '@fortawesome/fontawesome-pro/css/all.css'
/* ---- */

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/style.scss';

Vue.use(Toasted, {
  theme: "bubble",
  position: "top-right",
  duration: 3000
})

Vue.use(scrollTo);

// Vue.toasted.show('hola billo');

/*___TRANSLATE___*/
let lang = 'it';

let translations = require('./json/' + lang + '/translate.json');
let response = require('./json/' + lang + '/response.json');

/*___FILTERS___*/
Vue.filter('translate', function (string) {
    if (translations[string] != undefined)
        return translations[string];
    else
        return string;
});

Vue.filter('notification', function (data) {
  if (data.code == undefined)
    return;

  // console.log(data);

  //Verifico se l'error Code è == 1 (ha priorità rispetto agli altri codici)
  if (data.code == 1 && data.endpoint != 'logout')
    return response[1];
  //Verifico sia presente la response specifica per il codice di errore del metodo: NomeMetodo.Codice
  else if (response[data.endpoint][data.code] != undefined)
    return response[data.endpoint][data.code];
  //Verifico sia presente la response di errore generica per metodo: NomeMetodo.genericError
  else if (response[data.endpoint]['genericError'] != undefined)
    return response[data.endpoint]['genericError'];
  //Verifico sia presente la response generica per il codice d'errore: response.Codice
  else if (response[data.code])
    return response[data.code];

  return;    
});

/*___MIDDLEWARE___*/
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({
        name: 'login',
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters.loggedIn) {
      next({
        name: 'home',
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
